import React from 'react';
import {
    Route,
    Redirect
} from 'react-router-dom';
import {LOCAL_STORAGE_KEY} from "constants/constants";

const RouteWithLayout = props => {
    const { layout: Layout, component: Component, ...rest } = props;
    const loggedIn = localStorage.getItem(LOCAL_STORAGE_KEY)
    return (
        <Route
            {...rest}
            render={matchProps => {

                const { location } = matchProps
                if (!loggedIn) {
                    return (
                        <Redirect
                            to={{
                                pathname: "/auth/login",
                                state: { from: location }
                            }}
                        />
                    )
                }
                return (
                    <Layout>
                        <Component {...matchProps} />
                    </Layout>
                )
            }}
        />
    );
};

export default RouteWithLayout;
